var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserTick = function SvgUserTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M23.938 24.917c5.695 0 10.312-4.617 10.312-10.313 0-5.695-4.617-10.312-10.312-10.312-5.696 0-10.313 4.617-10.313 10.312 0 5.696 4.617 10.313 10.313 10.313M36.313 27.084a8.333 8.333 0 1 0 0 16.665 8.333 8.333 0 0 0 0-16.665m4.416 7.166-3.52 4.5a1.58 1.58 0 0 1-1.209.584 1.54 1.54 0 0 1-1.23-.605l-2.52-3.312a1.54 1.54 0 0 1 .27-2.084 1.54 1.54 0 0 1 2.084.271l1.313 1.667 2.291-2.917a1.545 1.545 0 0 1 2.438 1.896z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M42.417 43.27a15 15 0 0 0-3.313-7.04l-1.896 2.416a1.58 1.58 0 0 1-1.208.583 1.54 1.54 0 0 1-1.23-.604l-2.52-3.208a1.5 1.5 0 0 1-.187-1.521 1.5 1.5 0 0 1 1.541-2.084 20.8 20.8 0 0 0-9.666-2.333c-9.355-.02-17.146 5.938-18.48 13.792a2.354 2.354 0 0 0 2.5 2.562h31.98a2.353 2.353 0 0 0 2.479-2.562",
    opacity: 0.3
  })));
};
export default SvgUserTick;